function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect, useContext } from 'react';
import { connect, useSelector } from 'react-redux';
import { posActions } from '../../../reducers/pos.reducer';
import PageData from './Page.context';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Label from '../../common/form/Label.react';
import Input from '../../common/form/Input.react';
import Button from '../../common/Button.react';
import Textarea from '../../common/form/Textarea.react';
var PageSEO = function PageSEO(_ref) {
  var _defaultSEO$metadata, _defaultSEO$metadata2, _defaultSEO$metadata3, _defaultSEO$metadata4, _defaultSEO$metadata5, _defaultSEO$metadata6, _defaultSEO$metadata7;
  var pagesAction = _ref.pagesAction;
  var _useContext = useContext(PageData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var app = state.app,
    pageID = state.pageID,
    metadata = state.metadata,
    archived = state.archived;
  var cmsPages = useSelector(function (s) {
    return s.pos.pages;
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    defaultSEO = _useState2[0],
    setDefaultSEO = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  useEffect(function () {
    setDefaultSEO(Object.values(cmsPages).filter(function (x) {
      return x.clientApp === app;
    }).find(function (x) {
      return x.internalUrl === '/';
    }));
  }, [app, cmsPages]);
  useEffect(function () {
    var _metadata$tags, _metadata$tags$find, _metadata$tags2, _metadata$tags2$find;
    if (!metadata) return;
    setData(_objectSpread(_objectSpread({}, data), {}, {
      title: (metadata === null || metadata === void 0 ? void 0 : metadata.title) || '',
      description: (metadata === null || metadata === void 0 ? void 0 : (_metadata$tags = metadata.tags) === null || _metadata$tags === void 0 ? void 0 : (_metadata$tags$find = _metadata$tags.find(function (x) {
        return x.value === 'description';
      })) === null || _metadata$tags$find === void 0 ? void 0 : _metadata$tags$find.content) || '',
      keywords: (metadata === null || metadata === void 0 ? void 0 : (_metadata$tags2 = metadata.tags) === null || _metadata$tags2 === void 0 ? void 0 : (_metadata$tags2$find = _metadata$tags2.find(function (x) {
        return x.value === 'keywords';
      })) === null || _metadata$tags2$find === void 0 ? void 0 : _metadata$tags2$find.content) || ''
    }));
  }, [metadata]);
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "SEO Metadata"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Title"
  }), /*#__PURE__*/React.createElement(Input, {
    value: data === null || data === void 0 ? void 0 : data.title,
    onChange: function onChange(e) {
      return setData(_objectSpread(_objectSpread({}, data), {}, {
        title: e.target.value
      }));
    },
    placeholder: "Default: ".concat(defaultSEO === null || defaultSEO === void 0 ? void 0 : (_defaultSEO$metadata = defaultSEO.metadata) === null || _defaultSEO$metadata === void 0 ? void 0 : _defaultSEO$metadata.title)
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Description"
  }), /*#__PURE__*/React.createElement(Textarea, {
    value: data === null || data === void 0 ? void 0 : data.description,
    onChange: function onChange(e) {
      return setData(_objectSpread(_objectSpread({}, data), {}, {
        description: e.target.value
      }));
    },
    style: {
      height: 120
    },
    placeholder: "Default: ".concat(defaultSEO === null || defaultSEO === void 0 ? void 0 : (_defaultSEO$metadata2 = defaultSEO.metadata) === null || _defaultSEO$metadata2 === void 0 ? void 0 : (_defaultSEO$metadata3 = _defaultSEO$metadata2.tags) === null || _defaultSEO$metadata3 === void 0 ? void 0 : (_defaultSEO$metadata4 = _defaultSEO$metadata3.find(function (x) {
      return x.value === 'description';
    })) === null || _defaultSEO$metadata4 === void 0 ? void 0 : _defaultSEO$metadata4.content)
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Keywords (separate by ,)"
  }), /*#__PURE__*/React.createElement(Textarea, {
    value: data === null || data === void 0 ? void 0 : data.keywords,
    onChange: function onChange(e) {
      return setData(_objectSpread(_objectSpread({}, data), {}, {
        keywords: e.target.value
      }));
    },
    style: {
      height: 120
    },
    placeholder: "Default: ".concat(defaultSEO === null || defaultSEO === void 0 ? void 0 : (_defaultSEO$metadata5 = defaultSEO.metadata) === null || _defaultSEO$metadata5 === void 0 ? void 0 : (_defaultSEO$metadata6 = _defaultSEO$metadata5.tags) === null || _defaultSEO$metadata6 === void 0 ? void 0 : (_defaultSEO$metadata7 = _defaultSEO$metadata6.find(function (x) {
      return x.value === 'keywords';
    })) === null || _defaultSEO$metadata7 === void 0 ? void 0 : _defaultSEO$metadata7.content)
  })), !archived && /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Save",
    onClick: function onClick() {
      pagesAction({
        formData: {
          pageID: pageID,
          app: app,
          title: (data === null || data === void 0 ? void 0 : data.title) || '',
          description: (data === null || data === void 0 ? void 0 : data.description) || '',
          keywords: (data === null || data === void 0 ? void 0 : data.keywords) || ''
        },
        route: 'meta-data',
        method: 'post'
      });
    },
    permission: "edit-pos-sections"
  })))));
};
var mdtp = {
  pagesAction: posActions.pages
};
export default connect(null, mdtp)(PageSEO);